import { useMemo } from 'react';
import { Column, Typography } from '@tempmee/react';
import { UserProfession } from '~/enums/UserProfession';
import { getShouldFilterRenouncedProcedures } from '~/growthbook';
import { useAppSelector } from '~/hooks/useAppSelector';
import { IJob, IUser, ProfessionTypeEnum } from '~/models';
import { TNullable } from '~/types/Nullable';
import { EducationUtils } from '~/utils/EducationUtils';
import { filterObjectKeys } from '~/utils/Object';

interface IRdhFdProceduresProps {
  job: TNullable<IJob>;
  professional: TNullable<IUser>;
}

export const RdhFdProcedures = ({ professional, job }: IRdhFdProceduresProps) => {
  const procedureEndorsement = useAppSelector((store) => store.job.currentCandidateEndorsement);
  const candidateEducation = professional?.professional_info?.education;
  const candidateProfession = professional?.license?.profession;
  const profession = (job?.profession || candidateProfession) as ProfessionTypeEnum;
  const candidateSpecialtiesAndProcedures =
    candidateEducation?.[profession]?.specialtiesAndProcedures;
  const specialties = useMemo(
    () => Object.keys(filterObjectKeys(candidateSpecialtiesAndProcedures, 'specialty')),
    [candidateSpecialtiesAndProcedures],
  );

  const procedures = useMemo(() => {
    const procedures = EducationUtils.getProceduresOfProfession({
      specialtiesAndProcedures: candidateSpecialtiesAndProcedures,
      profession: candidateProfession,
      specialties,
    });

    if (getShouldFilterRenouncedProcedures() && procedureEndorsement) {
      const endorsements = procedureEndorsement.education?.specialtiesAndProcedures ?? [];

      return EducationUtils.getEndorsedProcedures({
        // @ts-expect-error - missing type
        endorsements,
        procedures,
        profession: candidateProfession,
      });
    }

    return procedures;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [candidateEducation, job?.profession]);

  return (
    [UserProfession.RDH, UserProfession.FD].includes(profession) && (
      <Column gap={2} style={{ marginLeft: 8, marginTop: 12 }}>
        {procedures.map((name) => (
          <Typography as="span" key={name}>{`\u2022  ${EducationUtils.removeProcedurePrefix(name)}`}</Typography>
        ))}
      </Column>
    )
  );
};
